import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digital-culture',
  templateUrl: './digital-culture.component.html',
  styleUrls: ['./digital-culture.component.sass']
})
export class DigitalCultureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
